<template>
	<section class="flex w-full vh-min flex-col">
		<form class="rounded-default p-4 bg-white" @submit="(e) => e.preventDefault()">
			<div class="flex flex-col">
				<label class="label-input" for="titulo">Título:</label>
				<input
					v-model="grupoProdutos.titulo"
					required
					type="text"
					class="input-custom"
					name="titulo"
				/>
			</div>
			<div class="flex flex-row flex-center mt-5">
				<Button
					title-color="#ffffff"
					border-radius="4px"
					height="35px"
					font-size="10px"
					background-color="#C70505"
					:is-loading="isFullDetailLoading"
					title="RESETAR"
					:icon="{
						type: 'rotate-ccw',
						size: '14px',
						color: '#FFF',
					}"
					@click="searchGrupo(grupoProdutos.id)"
				/>
				<Button
					class="ml-4"
					title-color="#ffffff"
					border-radius="4px"
					:is-loading="isLoadingUpdateComponent"
					font-size="10px"
					height="35px"
					background-color="#09AF5F"
					title="SALVAR TÌTULO"
					:icon="{
						type: 'save',
						size: '14px',
						color: '#FFF',
					}"
					@click="updateGrupo()"
				/>
			</div>
		</form>
		<div class="flex flex-row w-full box-div p-4 bg-white">
			<div class="w-full">
				<div v-if="!produtosVinculados || !produtosVinculados[0]" class="mb-5">
					<Button
						height="40px"
						width="150px"
						border-radius="5px"
						title="Vincular Tipo"
						:icon="{ type: 'plus', size: '14px', color: '#219653' }"
						@click="modalCriarTipo = !modalCriarTipo"
					/>
					<Modal
						v-if="modalCriarTipo"
						title="Vincular Tipo"
						width="30%"
						max-width="600px"
						@closemodal="
							modalCriarTipo = !modalCriarTipo;
							tipoSelecionado = false;
						"
					>
						<template v-slot:modalcontent>
							<form method="POST" @submit="(e) => vinculaTipo(e)">
								<div class="input-group flex flex-col mb-2">
									<label for="tipo">Tipo:</label>
									<select v-model="tipoSelecionado" class="select-custom" :options="varianteTipos">
										<option v-for="tipo of varianteTipos" :key="tipo.id" :value="tipo.id">
											{{ tipo.descricao }}
										</option>
									</select>
								</div>
								<div class="flex flex-row mt-4 items-center justify-center">
									<Button
										height="40px"
										margin-left="10px"
										width="150px"
										border-radius="5px"
										title="Cancelar"
										background-color="#d00000"
										title-color="#FFF"
										:icon="{
											type: 'x',
											size: '14px',
											color: '#FFF',
										}"
										@click="modalCriarTipo = !modalCriarTipo"
									/>
									<Button
										height="40px"
										width="150px"
										margin-left="10px"
										border-radius="5px"
										title="Vincular"
										title-color="#FFF"
										background-color="#219653"
										:icon="{
											type: 'save',
											size: '14px',
											color: '#FFF',
										}"
									/>
								</div>
							</form>
						</template>
					</Modal>
				</div>
				<div v-if="!produtosVinculados || !produtosVinculados[0]" class="mb-5">
					<span class="dica">
						<font-awesome-icon size="sm" color="#28c76f" icon="lightbulb" /> Vincule todos os tipos
						aplicáveis antes de adicionar os produtos!
					</span>
				</div>
				<div v-else class="mb-5">
					<span class="dica">
						<font-awesome-icon size="sm" color="#28c76f" icon="lightbulb" /> Para adicionar novos
						tipos, é necessário remover os produtos!
					</span>
				</div>
				<div class="flex">
					<TipoVariante
						v-for="(tipo, index) of varianteTiposVinculados"
						:key="index"
						:data="tipo"
						@delete="showRemoverTipo($event)"
						@dropdown-action="dropdownActions($event)"
					/>
					<Modal
						v-if="modalDesvincularTipo"
						title="Vincular Tipo"
						width="30%"
						max-width="600px"
						@closemodal="modalDesvincularTipo = !modalDesvincularTipo"
					>
						<template v-slot:modalcontent>
							<p class="text-center">
								Você está prestes a desvincular esse tipo do grupo, isso desvinculará também os
								produtos. Tem certeza disso?
							</p>
							<div class="flex flex-row mt-4 items-center justify-center">
								<Button
									height="40px"
									margin-left="10px"
									width="150px"
									border-radius="5px"
									title="Cancelar"
									background-color="#d00000"
									title-color="#FFF"
									:icon="{
										type: 'x',
										size: '14px',
										color: '#FFF',
									}"
									@click="modalDesvincularTipo = false"
								/>
								<Button
									height="40px"
									width="150px"
									margin-left="10px"
									border-radius="5px"
									title="Desvincular"
									title-color="#FFF"
									background-color="#219653"
									:icon="{
										type: 'save',
										size: '14px',
										color: '#FFF',
									}"
									@click="desvincularTipo()"
								/>
							</div>
						</template>
					</Modal>
				</div>
			</div>
		</div>
		<div class="flex flex-row rounded-default box-div mb-10">
			<div class="container-produtos">
				<div class="header-container flex flex-row justify-between items-center mb-6">
					<div class="flex flex-col">
						<span class="titulo-box">Produtos</span>
						<span v-if="produtosVinculados && produtosVinculados[0]" class="dica">
							<font-awesome-icon size="sm" color="#28c76f" icon="lightbulb" /> Para modificar os
							atributos de uma linha, é necessárioi remover e readicionar o produto!
						</span>
					</div>
					<div class="flex flex-row">
						<div>
							<Button
								width="150px"
								title-color="#ffffff"
								border-radius="3px"
								height="40px"
								font-size="10px"
								margin-left="10px"
								background-color="#FF8800"
								title="ADICIONAR PRODUTOS"
								:icon="{
									type: 'image',
									size: '14px',
									color: '#FFF',
								}"
								@click="addProdutoModal = !addProdutoModal"
							/>
							<Modal
								v-if="addProdutoModal"
								title="Adicionar Produto"
								width="calc(100% - 100px)"
								max-width="1500px"
								@closemodal="addProdutoModal = !addProdutoModal"
								@created="
									onSearchProduct();
									setProdutoData();
								"
							>
								<template v-slot:modalcontent>
									<form
										ref="formUpload"
										class="flex flex-col"
										method="post"
										enctype="multipart/form-data"
										@submit.prevent="onSearchProduct"
									>
										<Search
											width="100%"
											:bordered="true"
											height="35px"
											@searchtext="($event) => (searchProductText = $event)"
										/>
									</form>
									<div>
										<div class="flex flex-col mb-4">
											<div class="container-produto">
												<div
													v-for="(produto, index) of searchProdutosFiltered"
													:key="index"
													class="produto-item flex flex-col"
													:class="{
														selected: addProdutoData.produto_id === produto.id,
													}"
													@click="setProdutoData(produto.id)"
												>
													<input
														type="radio"
														name="radioProduto"
														:checked="addProdutoData.produto_id === produto.id"
													/>
													<div class="produto-imagem">
														<img :src="produto.src" alt="" loading="lazy" />
													</div>

													<span class="descricao">{{ produto.descricao }}</span>

													<div class="produto-info">
														<span>Cod: {{ produto.integracao_id }}</span>
														<span>Ean: {{ produto.ean }}</span>
													</div>
												</div>
											</div>
										</div>
										<div class="flex flex-row mb-4 input-group-custom">
											<div
												v-for="tipo of addProdutoData.tipos"
												:key="tipo.id"
												class="flex flex-col input-group-item"
											>
												<label class="input-label" :for="tipo.descricao">{{
													tipo.descricao
												}}</label>
												<select v-model="tipo.attrSelected" class="select-custom">
													Add
													<option></option>
													<option value="Manual">Digitar manualmente um novo</option>
													<option
														v-for="atributo of tipo.atributos"
														:key="atributo.id"
														:value="atributo.id"
													>
														{{ atributo.descricao }}
													</option>
												</select>
												<input
													v-if="tipo.attrSelected == 'Manual'"
													v-model="tipo.attrSelectedManual"
													class="input-custom"
													placeholder="Novo"
												/>
											</div>
										</div>
										<div class="flex flex-row items-center w-full mt-8 justify-center">
											<button class="btn-produto back" @click="addProdutoModal = !addProdutoModal">
												<feather
													type="x"
													class="mr-1"
													name="arrow-right"
													size="14"
													color="#ffffff"
												/>
												<span>Cancelar</span>
											</button>

											<button
												class="btn-produto next ml-4 flex flex-row items-center justify-center"
												@click="addProdutoGrupo"
											>
												<feather
													type="save"
													class="mr-1"
													name="arrow-right"
													size="14"
													color="#ffffff"
												/>
												<span>Adicionar Produto</span>
											</button>
										</div>
									</div>
								</template>
							</Modal>
						</div>
					</div>
				</div>
				<div>
					<Table
						style-class="vgt-table striped"
						:columns="generatedCols"
						:rows="produtosVinculadosFormatted"
						:compact-mode="true"
						@on-row-delete="onRowDelete($event)"
					/>
					<Modal
						v-if="deleteDialog"
						title="Remover Produto"
						heigth="500px"
						width="20%"
						@closemodal="deleteDialog = !deleteDialog"
					>
						<template v-slot:modalcontent>
							<p class="text-center">
								Você está prestes a remover o produto do grupo, tem certeza disso?
							</p>
							<div class="flex flex-row items-center w-full mt-4 justify-center">
								<button
									class="btn-steps back mr-4 flex flex-row items-center justify-center"
									@click="deleteDialog = !deleteDialog"
								>
									<span>Cancelar</span>
								</button>
								<div class="btn-steps next" @click="deleteDialogFunction">
									<span>Remover Produto</span>
								</div>
							</div>
						</template>
					</Modal>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
// eslint-disable-next-line import/extensions
import Button from '@/layout/components/buttons/Default.vue';
import * as ecAxios from '@/util/ecAxios';
// eslint-disable-next-line import/extensions
import Modal from '@/layout/components/modal/centered.vue';
// eslint-disable-next-line import/extensions
import Global from '@/mixins/global';
// eslint-disable-next-line import/extensions
import Table from '@/layout/components/table/vuegoodtable.vue';
import Search from '@/layout/components/search/new';
import TipoVariante from '@/layout/components/cards/tipovariante';
// import Treeselect from '@riophae/vue-treeselect';

export default {
	name: 'ComponentEdit',
	components: {
		Button,
		Modal,
		TipoVariante,
		Search,
		Table,
	},
	mixins: [Global],
	data() {
		return {
			step: {
				step1: false,
				step2: true,
			},
			isFullDetailLoading: false,
			updateProductDetailsLoading: false,
			isLoadingUpdateComponent: false,
			isLoadingUpdateImageDetails: false,
			sendNewImageOrderLoading: false,
			deleteDialog: false,
			addProdutoModal: false,
			addCategoriaModal: false,
			addProdutoData: {
				produto_id: '',
				tipos: [],
			},
			addCategoriaData: {
				categoria_id: [],
				dt_inicio: '',
				dt_fim: '',
				ordem: 1,
				tipo_visualizacao: 0,
			},
			componente: [],
			selectedFiles: [],
			preparedDeleteData: {},
			allViews: [],
			rowSelected: {},
			dragging: false,
			showDialog: false,
			uploadLoading: false,
			newImageOrder: [],
			searchProdutos: [],
			searchCategorias: [],
			imageSelected: null,
			errorToastOptions: {
				position: 'bottom-right',
				timeout: 5000,
				closeOnClick: true,
				pauseOnFocusLoss: true,
				pauseOnHover: true,
				draggable: true,
				draggablePercent: 0.6,
				showCloseButtonOnHover: false,
				hideProgressBar: true,
				closeButton: 'button',
				icon: true,
				rtl: false,
			},
			showModal: false,

			importProdutoModal: false,
			importCategoriaModal: false,
			productsImported: [],
			categoriesImported: [],
			searchProductText: '',
			sheetsFound: [],
			sheetsSelected: [],
			activeSheet: {},
			contadorAtributos: 0,
			modalCriarTipo: false,
			varianteTipos: [],
			tipoSelecionado: '',
			grupoProdutos: {},
			produtosVinculados: [],
			modalDesvincularTipo: false,
		};
	},
	computed: {
		productSelected() {
			if (this.rowSelected.produto !== undefined) {
				return this.rowSelected;
			}
			return {};
		},
		categoriaSelected() {
			if (this.rowSelected.categoria !== undefined) {
				return this.rowSelected;
			}
			return {};
		},
		varianteTiposVinculados() {
			if (this.grupoProdutos && this.grupoProdutos.variante_tipos) {
				return this.grupoProdutos.variante_tipos;
			}
			return [];
		},
		searchProdutosFiltered() {
			const produtosVinculadosIds = this.produtosVinculadosFormatted.map((item) => item.produto_id);
			return this.searchProdutos.filter(
				(item) => !produtosVinculadosIds.includes(item.id.toString())
			);
		},
		produtosVinculadosFormatted() {
			if (this.produtosVinculados === []) return [];
			const objectFormatted = {};
			const retorno = [];
			this.produtosVinculados.forEach((item) => {
				if (objectFormatted[item.produto_id]) {
					objectFormatted[item.produto_id][item.tipo.descricao] = item.atributo.descricao;
				} else {
					objectFormatted[item.produto_id] = {
						Produto: item.produto.descricao,
						[item.tipo.descricao]: item.atributo.descricao,
					};
				}
			});

			Object.keys(objectFormatted).forEach((key) => {
				retorno.push({
					produto_id: key,
					dados: objectFormatted[key],
				});
			});
			retorno.acoes = '';
			return retorno;
		},
		generatedCols() {
			if (!this.produtosVinculadosFormatted[0]) {
				return [];
			}
			const cols = [];
			Object.keys(this.produtosVinculadosFormatted[0].dados).forEach((key) => {
				cols.push({
					label: key,
					field: `dados.${key}`,
					type: 'string',
				});
			});
			cols.push({
				label: 'Ações',
				field: 'acoes',
				type: 'string',
				tdClass: 'text-center',
				thClass: 'text-center',
			});
			return cols;
		},
	},
	created() {
		const grupoId = this.$route.params.id;
		this.searchTipos();
		this.searchGrupo(grupoId);
		this.searchProdutosVinculados(grupoId);
	},
	methods: {
		showRemoverTipo(id) {
			this.modalDesvincularTipo = true;
			this.tipoSelecionado = id;
		},
		async desvincularTipo() {
			try {
				this.modalDesvincularTipo = false;
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.PRODUTO_GRUPO_TIPO_DESVINCULAR}/${this.tipoSelecionado}`;
				const { data } = await ecAxios.connection().delete(url);
				this.searchGrupo(this.$route.params.id);
				this.searchProdutosVinculados(this.$route.params.id);

				if (data.error) {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error.message, this.errorToastOptions);
			}
		},
		setProdutoData(produtoId) {
			this.addProdutoData = {
				produto_id: produtoId || '',
				tipos: this.varianteTiposVinculados.map((item) => ({
					...item.variante_tipo,
					attrSelected: '',
					attrSelectedManual: '',
				})),
			};
		},
		async searchGrupo(grupoId) {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.PRODUTO_GRUPO}?id=${grupoId}&varianteTipos=true`;
				const { data } = await ecAxios.connection().get(url);

				if (!data.error) {
					this.grupoProdutos = data.grupos['0'];
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error.message, this.errorToastOptions);
			}
		},
		async searchTipos() {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.PRODUTO_GRUPO_TIPOS}`;
				const { data } = await ecAxios.connection().get(url);

				if (!data.error) {
					this.varianteTipos = data.tipos;
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error.message, this.errorToastOptions);
			}
		},
		async searchProdutosVinculados(grupoId) {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.PRODUTO_GRUPO_PRODUTOS_VINCULADOS}`;
				const { data } = await ecAxios.connection().get(url, { params: { grupo_id: grupoId } });

				if (!data.error) {
					this.produtosVinculados = data;
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error.message, this.errorToastOptions);
			}
		},
		async vinculaTipo(event) {
			event.preventDefault();

			if (!this.tipoSelecionado) {
				this.$toast.error('Selecione um tipo a ser vinculado!', this.errorToastOptions);
				return;
			}

			const requestdata = {
				variante_tipo_id: this.tipoSelecionado,
				grupo_produto_id: this.grupoProdutos.id,
			};

			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.PRODUTO_GRUPO_TIPO_VINCULAR}`;
				const { data } = await ecAxios.connection().post(url, requestdata);

				if (!data.error) {
					this.searchGrupo(this.$route.params.id);
					this.modalCriarTipo = !this.modalCriarTipo;
					this.tipoSelecionado = false;
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error.message, this.errorToastOptions);
			}
		},

		async updateGrupo() {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.PRODUTO_GRUPO}`;
				const { data } = await ecAxios.connection().put(url, this.grupoProdutos);

				if (!data.error) {
					this.$toast.success('Grupo atualizado com sucesso!', this.errorToastOptions);
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error.message, this.errorToastOptions);
			}
			this.searchGrupo(this.grupoProdutos.id);
		},
		async addProdutoGrupo() {
			const formData = {};
			let invalid = false;
			if (!this.addProdutoData.produto_id) {
				this.$toast.warning('Você precisa selecionar um produto', this.errorToastOptions);
				return;
			}
			formData.produto_id = this.addProdutoData.produto_id;
			formData.grupo_id = this.$route.params.id;
			formData.tipos = [];
			this.addProdutoData.tipos.forEach((item) => {
				if (!item.attrSelected || (item.attrSelected === 'Manual' && !item.attrSelectedManual)) {
					invalid = true;
				}
				if (item.attrSelected !== 'Manual') {
					formData.tipos.push({ variante_id: item.id, atributo_id: item.attrSelected });
				} else {
					formData.tipos.push({
						variante_id: item.id,
						atributo_id: '',
						atributo_manual: item.attrSelectedManual,
					});
				}
			});
			if (invalid) {
				this.$toast.warning(
					'É necessário selecionar uma opção para cada tipo listado',
					this.errorToastOptions
				);
				return;
			}
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.PRODUTO_GRUPO_VINCULAR_PRODUTO}`;
				const { data } = await ecAxios.connection().post(url, formData);
				if (!data.error) {
					this.addProdutoModal = false;
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.warning(error.message, this.errorToastOptions);
			}
			this.searchProdutosVinculados(this.$route.params.id);
			this.searchGrupo(this.$route.params.id);
		},
		deleteDialogFunction(data) {
			if (data.action === 0) {
				this.deleteDialog = !this.deleteDialog;
			} else {
				this.deleteDialog = !this.deleteDialog;
				this.deleteProdutoGrupo(this.preparedDeleteData);
			}
			this.preparedDeleteData = {};
		},
		onRowDelete(row) {
			this.deleteDialog = !this.deleteDialog;
			this.preparedDeleteData = row;
		},
		async deleteProdutoGrupo(row) {
			const grupoId = this.$route.params.id;
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.PRODUTO_GRUPO_DESVINCULAR_PRODUTO}`;
				const { data } = await ecAxios
					.connection()
					.post(url, { grupo_id: grupoId, produto_id: row.produto_id });

				if (data.error) {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error.message, this.errorToastOptions);
			}
			this.searchProdutosVinculados(grupoId);
		},
		async onSearchProduct() {
			const key = this.searchProductText || '';

			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.PRODUTOS_SHOWALL}`;
				const { data } = await ecAxios.connection().post(url, {
					searchterm: key,
					// limit: 50,
				});
				if (!data.error) {
					const { produtos } = data;

					produtos.map((produto) => {
						// eslint-disable-next-line no-param-reassign
						produto.src = `https://img.dpcnet.com.br/catalogo/${produto.integracao_id}.png`;
						return produto;
					});

					this.searchProdutos = data.produtos;
				} else {
					throw new Error(data.message);
				}
			} catch (error) {
				this.$toast.error(error.message.message, this.errorToastOptions);
			}
		},
		async checkProductOrder(ordem) {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC}${api.env.COMPONENTE_PRODUTO_CHECK_ORDER}/${this.componente.componente_id}/${ordem}`;
				const { data } = await ecAxios.connection().get(url);
				if (!data.error) {
					return data.isAvailable;
				}
				throw new Error(data.message);
			} catch (error) {
				this.$toast.warning(error.message, this.errorToastOptions);
				return false;
			}
		},
		cleanOnCloseModal() {
			this.productsImported = [];
			this.categoriesImported = [];
			this.activeSheet = {};
			this.sheetsSelected = [];
			this.sheetsFound = [];
		},
	},
};
</script>

<style scoped lang="scss">
@import '~@/style/Global.css';

.select-custom {
	border: 1px solid #e2eaf5;
	border-radius: 4px;
	padding: 4px;
}

@keyframes is-rotating {
	to {
		transform: rotate(1turn);
	}
}

section {
	display: flex;
}

.produto-imagem {
	width: 100%;
	height: 100px;
	display: flex;
	align-items: center;
	justify-content: center;
	img {
		padding: 5px;
		height: 100%;
	}
}
.input-group-custom {
	display: flex;
	flex-direction: row;
	justify-content: space-between;

	.input-group-item:nth-child(1) {
		width: 35%;
	}
	.input-group-item:nth-child(2) {
		width: 35%;
	}
	.input-group-item:nth-child(3) {
		width: 20%;
	}
}

.produto-item {
	padding: 10px;
	transition: var(--default-transition);
	cursor: pointer;
	display: flex;
	margin-right: 5px;
	margin-top: 10px;
	margin-bottom: 10px;
	border-radius: 3px;
	width: 32%;
	border: 1px solid #e2eaf5;

	&:hover {
		border: 1px solid #09af5f;
		box-shadow: var(--default-shadow);
	}
	.descricao {
		margin-top: 10px;
		font-size: 12px;
		font-weight: bold;
		margin-bottom: 5px;
	}
	.produto-info {
		font-size: 10px;
		display: flex;
		flex-direction: column;
	}
}

.titulo-box {
	font-size: 16px;
	font-weight: bold;
}

.selected {
	border: 1px solid #09af5f;
	box-shadow: var(--default-shadow);
}

.container-produto {
	margin-top: 20px;
	max-width: 100%;
	height: calc(100vh - 400px);
	max-height: 550px;
	flex-wrap: wrap;
	display: flex;
	justify-content: space-between;
	flex-direction: row;
	overflow-x: auto;
}

.box-div {
	margin-top: 30px;
}
.label-input {
	font-size: 12px;
	font-weight: bold;
	color: #666666;
	margin-top: 10px;
	margin-bottom: 3px;
}
.input-custom {
	border: 1px solid #e2eaf5;
	padding: 3px;
	border-radius: 4px;
}
.dica {
	font-size: 12px;
	padding: 5px;
	margin-top: 5px;
	border-radius: var(--default-border-radius);
	color: #28c76f;
	background-color: #28c76f1f;

	&.alert {
		color: #dfa108;
		background-color: #ffb70314;
	}
}

#delete-image {
	margin-left: 5px;
	&:hover {
		color: #c70505;
	}
}

.input-label {
	font-size: 12px;
	font-weight: bold;
	color: #666666;
}

.btn-steps,
.btn-produto {
	all: unset;
	font-size: 10px;
	text-transform: uppercase;
	padding: 5px;
	width: 150px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 3px;
	font-weight: bold;
	color: #fff;
	transition: ease-in-out 0.3s;
}
.next {
	background-color: var(--primary-color);
}
.next:hover {
	cursor: pointer;
	background-color: darken(#09af5f, 10%);
}
.back {
	background-color: red;
}
.back:hover {
	cursor: pointer;
	background-color: darken(red, 10%);
}

.container-produtos {
	background-color: var(--white-color);
	padding: 30px;
	width: 100%;
}
</style>

